// Instance
import { authInstance } from '@/app/apis/auth/_connection/auth-connection-api.js';

export default class AuthAPI {
	constructor() {
		this.axios = authInstance;
	}

	/**
	 * @param {*} targetFile
	 * @return - (string) ex. ?q=blah123&f_formReportId=1&f_statusId=3&sortBy=title&desc=true&page=1&limit=20
	 */
	reusableAPIMethod(targetFile) {
		return 'test';
	}
}
